import { Button, ButtonAppearance, RemoveIcon } from '@aleph/shared-components';
import EntityEditIconNotAllowed from 'wb-reddit/src/app/common/components/EntityEditIconNotAllowed';
import { useTranslation } from 'react-i18next';

function EntityOwnerDisplay() {
	const { t } = useTranslation();

	return (
		<EntityEditIconNotAllowed
			tooltipText={t('re: revoke err', 'Owner\'s access can not be revoked; requires ownership change.')}
			icon={
				<Button
					leftNode={<RemoveIcon
						width={16}
						height={16}
					/>}
					appearance={ButtonAppearance.GHOST}
					color="gray"
					disabled
				/>
			}
		/>
	);
}

export default EntityOwnerDisplay;
